define([
  'redux',
  'es6!launcher/reducers/AppReducers',
  'es6!launcher/actions/ListBuilderActions',
  'es6!launcher/actions/ShortcutsActions',
], (redux, AppReducers, ListBuilderActions, ShortcutsActions) => {
  let hasDispatchedValidate = false;

  function thunkMiddleware({ dispatch, getState }) {
    return next => (action) => {
      if (typeof action === 'function') {
        return action(dispatch, getState);
      }

      return next(action);
    };
  }

  // This middleware dispatches a validation event on all actions that
  // each reducer can subscribe to for validations.
  function validationMiddleware({ dispatch, getState }) {
    return next => (action) => {
      // Prevent infinite loop by not validating validate actions.
      if (
        !hasDispatchedValidate &&
        action.type !== ListBuilderActions.VALIDATE &&
        action.type in ListBuilderActions
      ) {
        // Limiting the validations to one per js event loop.
        hasDispatchedValidate = true;
        // We need a setTimeout since we are in a dispatch currently.
        setTimeout(() => {
          hasDispatchedValidate = false;
          dispatch({ type: ListBuilderActions.VALIDATE, fullState: getState() });
        }, 0);
      }

      if (action.type !== ShortcutsActions.VALIDATE_SHORTCUT && action.type in ShortcutsActions) {
        setTimeout(() => {
          dispatch({ type: ShortcutsActions.VALIDATE_SHORTCUT, fullState: getState() });
        });
      }

      return next(action);
    };
  }

  const createEnhancedStore = redux.compose(
    redux.applyMiddleware(thunkMiddleware),
    redux.applyMiddleware(validationMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
  )(redux.createStore);

  let current = null;

  // A fresh store per app boot. The launcher app is the owner: it calls
  // `create()` on init so a site switch starts from empty state instead of
  // inheriting the previous site's data (e.g. its popups/forms list).
  const create = () => {
    hasDispatchedValidate = false;
    current = createEnhancedStore(AppReducers);
    return current;
  };

  // Hands back the live store. Lazily creates one for callers that read before
  // the launcher has booted, preserving the old always-available behavior.
  const get = () => current || create();

  return { create, get };
});
